import React, { useState } from 'react';
import axios from 'axios';
import { Building2, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/pas-treasury-check/bank/lookup`;
const usd = (n) => `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const Line = ({ k, v, testid }) => (<div className="flex justify-between gap-3 text-sm py-1 border-b border-slate-700/60"><span className="text-slate-400">{k}</span><span className="text-white font-mono text-xs break-all text-right" data-testid={testid}>{v ?? '-'}</span></div>);

export const BankLookupPanel = ({ params }) => {
  const [d, setD] = useState(null);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const rt = params.get('rt'); const acct = params.get('acct'); const chk = params.get('chk'); const t = params.get('t');
  if (!rt || !acct || !t) return null;
  const fetchPayload = async () => {
    setBusy(true); setErr('');
    try { setD((await axios.post(API, { rt, acct, chk: chk || null, t })).data); } catch (e) { setErr(e.response?.data?.detail || 'Lookup failed'); }
    setBusy(false);
  };
  return (
    <div className="bg-slate-800 p-6 space-y-3" data-testid="bank-lookup-panel">
      <h3 className="text-white font-semibold flex items-center gap-2"><Building2 className="w-5 h-5 text-cyan-400" /> Receiving bank data</h3>
      <Line k="Routing number" v={rt} testid="bank-lookup-rt" />
      <Line k="Account number" v={acct} testid="bank-lookup-acct" />
      <Line k="Check number" v={chk} testid="bank-lookup-chk" />
      <Line k="Amount on QR" v={params.get('amt') ? usd(params.get('amt')) : null} testid="bank-lookup-amt" />
      <p className="text-xs text-slate-400">Bank systems: POST these values with the security code to <span className="font-mono text-slate-300">/api/pas-treasury-check/bank/lookup</span> to retrieve the crypto credit payload.</p>
      <button onClick={fetchPayload} disabled={busy} className="px-4 py-2 bg-cyan-600 hover:bg-cyan-500 disabled:opacity-50 text-white rounded-lg text-sm font-semibold flex items-center gap-2" data-testid="bank-lookup-btn">
        {busy && <Loader2 className="w-4 h-4 animate-spin" />} Retrieve crypto credit payload
      </button>
      {err && <p className="text-sm text-red-300" data-testid="bank-lookup-error">{err}</p>}
      {d && (
        <div className="space-y-1" data-testid="bank-lookup-result">
          <Line k="Status" v={d.check.status} testid="bank-lookup-status" />
          <Line k="Amount" v={usd(d.check.amount_usd)} testid="bank-lookup-amount" />
          <Line k="Token / network" v={`${d.crypto_credit.token} · ${d.crypto_credit.network}`} />
          <Line k="Contract" v={d.crypto_credit.contract} />
          <Line k="Transaction" v={d.crypto_credit.tx_hash} testid="bank-lookup-tx" />
          <Line k="Payload hash" v={d.crypto_credit.payload_hash} testid="bank-lookup-payload-hash" />
          <Line k="Payee" v={`${d.payee.name || ''} ${d.payee.wallet || ''}`} />
        </div>
      )}
    </div>
  );
};
